import React, {Fragment, useState} from 'react';
import {Button, Icon, Modal} from 'antd';
import Call from '../../../../hocs/call';
import {
  deleteFileMappingListFileMapping,
  deleteFileMappingListFileMappingAll,
  deleteFileMappingListSequenceMapping,
  hideFileMappingListFileMapping,
  hideFileMappingListSequenceMapping,
  hideNewSequenceMappingForm,
  readFileMappingListFileMapping,
  readFileMappingListFileMappingCube,
  readFileMappingListFileMappings,
  readFileMappingListSequenceMapping,
  saveNewSequenceMapping,
  showFileMappingListFileMapping,
  showFileMappingListSequenceMapping,
  showNewSequenceMappingForm
} from './actions';
import { MODAL_WIDTH_MD, MODAL_WIDTH_SM} from '../../../../styles/constants';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import FileMappingForm from '../../../../components/file-mapping-form';
import EnhancedModal from '../../../../components/enhanced-modal';
import {showFileMappingWizard} from "../wizard/actions";
import EnhancedTree from "../../../../components/enhanced-tree";
import {getNodes} from "../../../../utils/tree";
import {getLocalizedStr} from "../../../../middlewares/i18n/utils";
import {BUTTON_DELETE, BUTTON_DETAIL} from "../../../../styles/buttons";
import { canSelectMultiple, getSelectedNodes, getSequenceMappingMappings, initialSequenceMapping } from './utils';
import NewSequenceMappingForm from '../../../../components/file-mapping-sequence-mapping-form/NewSequenceMappingForm';
import SequenceMappingForm from '../../../../components/file-mapping-sequence-mapping-form';
import _ from 'lodash';


const IconFontCNIcon = Icon.createFromIconfontCN({
  scriptUrl: './static/vendor/iconfont_cn/iconfont.js',
});

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  fileMappingsTree: state.scenes.dataManager.fileMapping.components.list.fileMappingsTree,
  fileMappingId: state.scenes.dataManager.fileMapping.components.list.fileMappingId,
  fileMapping: state.scenes.dataManager.fileMapping.components.list.fileMapping,
  fileMappingCube: state.scenes.dataManager.fileMapping.components.list.fileMappingCube,
  isNewSequenceMappingFormVisible: state.scenes.dataManager.fileMapping.components.list.isNewSequenceMappingFormVisible,
  sequenceMappingId: state.scenes.dataManager.fileMapping.components.list.sequenceMappingId,
  sequenceMapping: state.scenes.dataManager.fileMapping.components.list.sequenceMapping,
});

const mapDispatchToProps = dispatch => ({
  onWizardShow: (cubeId, cubeCode) => dispatch(showFileMappingWizard(cubeId, cubeCode)),
  onFileMappingShow: fileMappingId => dispatch(showFileMappingListFileMapping(fileMappingId)),
  onFileMappingHide: () => dispatch(hideFileMappingListFileMapping()),
  onFileMappingDelete: fileMappingId => dispatch(deleteFileMappingListFileMapping(fileMappingId)),
  onFileMappingDeleteAll: fileMappingIds => dispatch(deleteFileMappingListFileMappingAll(fileMappingIds)),
  fetchFileMappings: () => dispatch(readFileMappingListFileMappings()),
  fetchFileMapping: fileMappingId => dispatch(readFileMappingListFileMapping(fileMappingId)),
  fetchFileMappingCube: cubeId => dispatch(readFileMappingListFileMappingCube(cubeId)),
  onShowNewSequenceMappingForm: () => dispatch(showNewSequenceMappingForm()),
  onHideNewSequenceMappingForm: () => dispatch(hideNewSequenceMappingForm()),
  onSaveNewSequenceMapping: (idCube, name, description, mappingsIDs, pluginId) => dispatch(saveNewSequenceMapping(idCube, name, description, mappingsIDs, pluginId)),
  onSequenceMappingShow: sequenceMappingId => dispatch(showFileMappingListSequenceMapping(sequenceMappingId)),
  onSequenceMappingHide: () => dispatch(hideFileMappingListSequenceMapping()),
  onSequenceMappingDelete: sequenceMappingId => dispatch(deleteFileMappingListSequenceMapping(sequenceMappingId)),
  fetchSequenceMapping: sequenceMappingId => dispatch(readFileMappingListSequenceMapping(sequenceMappingId)),
});

const FileMappingList = ({
                           t,
                           appLanguage,
                           dataLanguages,
                           fileMappingsTree,
                           fileMappingId,
                           fileMapping,
                           fileMappingCube,
                           isNewSequenceMappingFormVisible,
                           sequenceMappingId,
                           sequenceMapping,
                           onWizardShow,
                           onFileMappingShow,
                           onFileMappingHide,
                           onFileMappingDelete,
                           fetchFileMappings,
                           fetchFileMapping,
                           fetchFileMappingCube,
                           onShowNewSequenceMappingForm,
                           onHideNewSequenceMappingForm,
                           onSaveNewSequenceMapping,
                           onSequenceMappingShow,
                           onSequenceMappingHide,
                           onSequenceMappingDelete,
                           fetchSequenceMapping,
                         }) => {

  const [selected, setSelected] = useState(null);
  const [selectedKeys, setSelectedKeys] = useState(null);
  const [selectedNodes, setSelectedNodes] = useState(null);
  const [newSequenceMapping, setNewSequenceMapping] = useState(initialSequenceMapping);



  const handleOnSelect = (selectedKeysFromTree) => {  
    let currentlySelectedKeys = []; 
    setSelectedNodes(null);
    const selectedKeysArr = selectedKeysFromTree || [];
   
    if (selectedKeysArr.length >= 1) {

      if (canSelectMultiple(selectedKeysArr, fileMappingsTree)) {
        currentlySelectedKeys = selectedKeysArr;
        setSelectedNodes(getSelectedNodes(currentlySelectedKeys, fileMappingsTree));
      } else {
        currentlySelectedKeys = selectedKeysArr.slice(-1);
      }
    }        
    if (currentlySelectedKeys.length === 1) {
      setSelected(currentlySelectedKeys[0]);      
    } else {
      setSelected(null);
    }
    setSelectedKeys(currentlySelectedKeys);
  } 

  const onChangeSequenceMapping = (changedFields) => {
    const newSequenceMappingClone = _.cloneDeep(newSequenceMapping);
    _.merge(newSequenceMappingClone, changedFields);
    setNewSequenceMapping(newSequenceMappingClone);
  }

  const saveNewSequenceMapping = () => {
    const idCube = selectedNodes[0].IDCube;
    const pluginUid =  !!selectedNodes[0].PluginId ? selectedNodes[0].PluginId : null
    const mappingsIDs = [];
    selectedNodes.forEach(node => {
      mappingsIDs.push(node.IDMapping);
    });
    setSelectedKeys(null);
    setSelectedNodes(null);
    onSaveNewSequenceMapping(idCube, newSequenceMapping.name, newSequenceMapping.description, mappingsIDs, pluginUid);
  }

  
  return (
    <Fragment>
      <EnhancedModal
        visible={fileMappingId !== null}
        onCancel={onFileMappingHide}
        title={t('scenes.dataManager.fileMapping.list.fileMappingModal.title')}
        width={MODAL_WIDTH_SM}
        footer={<Button onClick={onFileMappingHide}>{t('commons.buttons.close.title')}</Button>}
        withDataLanguageSelector
       >
        <Call cb={fetchFileMapping} cbParam={fileMappingId}>
          <Call
            cb={fetchFileMappingCube}
            cbParam={fileMapping !== null && fileMapping.IDCube}
            disabled={fileMapping === null}
          >
            <FileMappingForm fileMapping={fileMapping} cube={fileMappingCube}/>
          </Call>
        </Call>
      </EnhancedModal>
      <EnhancedModal
        visible={sequenceMappingId !== null}
        onCancel={onSequenceMappingHide}
        title={t('scenes.dataManager.fileMapping.list.sequenceMappingModal.title')}
        width={MODAL_WIDTH_SM}
        footer={<Button onClick={onSequenceMappingHide}>{t('commons.buttons.close.title')}</Button>}
        withDataLanguageSelector
      >
        <Call cb={fetchSequenceMapping} cbParam={sequenceMappingId}>
          <Call
            cb={fetchFileMappingCube}
            cbParam={sequenceMapping !== null && sequenceMapping.IDCube}
            disabled={sequenceMapping === null}
          >
            <SequenceMappingForm 
              sequenceMapping={sequenceMapping} 
              cube={fileMappingCube}
              components={(sequenceMapping  && fileMappingsTree) ?
                getSequenceMappingMappings(sequenceMapping, fileMappingsTree)
              : []}
            />
          </Call>
        </Call>
      </EnhancedModal>
      <EnhancedModal
        visible={isNewSequenceMappingFormVisible}
        onCancel={onHideNewSequenceMappingForm}
        title={t('scenes.dataManager.fileMapping.list.newSequenceForm.title', {numberOfMappings: (selectedNodes || []).length})}
        width={MODAL_WIDTH_MD}
        footer={
          <Button 
            type="primary"
            onClick={() => saveNewSequenceMapping()}
            disabled={!newSequenceMapping || (newSequenceMapping.name || "").length === 0}
            >
            {t('commons.buttons.save.title')}
          </Button>
        }
      >    
        <NewSequenceMappingForm 
          onChange={onChangeSequenceMapping}
          />    
      </EnhancedModal>    
        <Call cb={fetchFileMappings} disabled={fileMappingsTree !== null}>
          <EnhancedTree
            tree={fileMappingsTree}
            idKey="TreeID"
            nameKey="Name"
            childrenKey="children"
            catIdKey="TreeID"
            catNameKey="labels"
            getIsNameMultilanguage={node => !node.IDMapping && !node.IDSeqMapping}
            multiple
            selectedKeys={selectedKeys ? selectedKeys : []}
            unselectableKeys={
              getNodes(fileMappingsTree, 'children', node => !(node.IDMapping || node.IDSeqMapping) && !node.IDCube)  
                .map(node => node.TreeID)
            }
            hiddenIdKeys={
              getNodes(fileMappingsTree, 'children', (({Code}) => !Code))
                .map(node => node.TreeID)
            }
            getIcon={({Code, IDMapping, XMLFilePath, IDSeqMapping, IconName, IconColor, PluginId}) => {
          
              if (Code) {
                return (
                  <IconFontCNIcon
                    theme="filled"
                    style={{color: "#37a0f4"}}
                    type="cube"
                  />
                );
              } 
              else if (IDMapping) {
                if(PluginId && IconName){
                  return (
                    <Icon
                      theme="outlined"
                      type={!!IconName ? IconName : "file-text"}
                      style={{color: !!IconColor ? _.lowerCase(IconColor.replaceAll('_','')) : "grey"}}
                    />
                  );
                }
                else if (XMLFilePath && !PluginId) {
                  return (
                    <Icon
                      theme="outlined"
                      type="file-excel"
                      style={{color: "green"}}
                    />
                  );
                } else {
                  return (
                    <Icon
                      theme="outlined"
                      type="file-text"
                    />
                  );
                }
                
              } else if (IDSeqMapping) {                
                  return (
                    <Icon
                      theme="outlined"
                      type={!!IconName ? IconName : "file-excel"}
                      style={{color: !!IconColor ? _.lowerCase(IconColor.replaceAll('_','')) : "blue"}}
                    />
                  );          
              } else {
                return null;
              }
            }}
            getFilter={
              searchText =>
                ({labels, Code, Name}) => {
                  const search = searchText.toLowerCase();
                  return (Name && Name.toLowerCase()
                      .indexOf(search) >= 0) ||
                    (Code && Code.toLowerCase()
                      .indexOf(search) >= 0) ||
                    (labels && getLocalizedStr(labels, appLanguage, dataLanguages)
                      .toLowerCase()
                      .indexOf(search) >= 0);
                }
            }
            onSelect={selectedArr => handleOnSelect(selectedArr)}
            treeActions={[
              {
                title: t('scenes.dataManager.loader.csvForm.mappingControl.refreshTree.title'),
                icon: 'sync',
                onClick: fetchFileMappings
              },
              {
                title: t('scenes.dataManager.fileMapping.wizardShowButton.label'),
                icon: 'plus',
                onClick: () => {
                if (selected && !selected.startsWith("Mapp_")  && !selected.startsWith("SeqMapp_")) {
                  onWizardShow(
                    getNodes(
                      fileMappingsTree,
                      'children',
                        node => !!node.IDCube
                    ).find(({Code}) => Code === selected.replace("Mapp_", "")).IDCube,
                    selected
                  );
                } else {
                  onWizardShow();
                }
                }
              }
            ]}
            actions={
              (() => {
                if (selected && (selected.startsWith("Mapp_") || selected.startsWith("SeqMapp_"))) { 
                  let id;
                  let name = "";
                  let components;
                  const isMapping = selected.startsWith("Mapp_");
                  if (isMapping) {
                    id = Number(selected.replace("Mapp_", ""));
                    components = getNodes(fileMappingsTree, 'children', ({IDMapping}) => IDMapping === id) || [];                
                  } else {
                    id = Number(selected.replace("SeqMapp_", ""));
                    components = getNodes(fileMappingsTree, 'children', ({IDSeqMapping}) => IDSeqMapping === id) || [];
                  }
                  if (components.length > 0 && components[0]) {
                    name = components[0].Name || "";
                  }
                  return [
                    {
                      ...BUTTON_DETAIL,
                      title: t('components.itemList.actions.view.title'),
                      onClick: () => {
                        if (isMapping) {
                          onFileMappingShow(id);
                        } else {
                          onSequenceMappingShow(id);
                        }                      
                      }
                    },
                    {
                      ...BUTTON_DELETE,
                      title: t('components.itemList.actions.delete.title'),
                      onClick: () => Modal.confirm({
                        title: isMapping 
                        ? t('scenes.dataManager.fileMapping.list.fileMapping.deleteButton.confirm', {id:name})
                        : t('scenes.dataManager.fileMapping.list.sequenceMapping.deleteButton.confirm', {id:name}),
                        onOk() {
                          setSelected(null);
                          setSelectedKeys(null);
                          setSelectedNodes(null);
                          if (isMapping) {
                            onFileMappingDelete(id);
                          } else {
                            onSequenceMappingDelete(id);
                          }
                          
                        },
                        cancelText: t('commons.buttons.cancel.title')
                      })
                    }
                  ];
                } else {
                  return null;
                }
              })()
            }
            rightClickActions={[
              node => (selectedKeys || []).length >= 2 && selectedKeys.includes(`Mapp_${node.IDMapping}`)
                ? ({
                  icon: "file-excel",
                  className: "button-color-green",
                  title: t('scenes.dataManager.fileMapping.list.actions.createSequenceMapping.title'),
                  onClick: () => onShowNewSequenceMappingForm()
                })
                : null,            
            ]}         
          />
        </Call>
    </Fragment>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(FileMappingList);
